import React from 'react';
import { get, isUndefined } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// local dependencies
import { callAuthorizationFlow as CallAuthorizationFlow } from 'ui/views/widgets/callAuthorizationFlow';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { CallAuthorizationFlowService } from 'services/callAuthorizationFlow';
import { REDUCER } from 'constants/entity-names';
import { updateCallState } from 'store/actions/callState';
import { getStore } from 'store';

// get a global redux store ( creates empty store if not already created )
const store = getStore();

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallAuthorizationFlowWidget } from 'ui/containers/CallAuthorizationFlowWidget';
 *
 * // render
 * <CallAuthorizationFlowWidget propName='propValue'/>
 */
class _CallAuthorizationFlowWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.callAuthorizationFlowService = new CallAuthorizationFlowService();

        // redirect to the landing page if no call is ongoing, else start data fetch
        // if( isEmpty( get( props, 'callState', {} ) ) ) {
        //     props.history.push( DASHBOARD_SUB_ROUTES.CALL_MANAGEMENT_LISTS );
        // } else {
            this.fetchComponentData();
            
        // }
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'CallAuthorizationFlowWidget.fetchComponentData()' );

        // cancel ongoing request
        this.callAuthorizationFlowService.cancel();

        // fetch component data
        const { status, data } = await this.callAuthorizationFlowService.fetchComponentData( {
            url: this.props.widget.url,
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {

            // check if URL contains `step` query parameter.
            const queryParams = queryString.parse( this.props.location.search );
            let currentStep = get( queryParams, 'step', undefined );

             // check if the user verification status, is present in the store
            const memberVerificationState = store.getState()[ REDUCER.MEMBER_VERIFICATION_STATE ];

            // if user verification data is present, send the user to 2nd step
            if( ! isUndefined( get( memberVerificationState, 'memberId' ) ) ) {
                currentStep = 2;
            }
            
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
                currentStep: currentStep > data.steps.length ? '1' : currentStep, // caution
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.callAuthorizationFlowService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallAuthorizationFlow
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                currentStep={ this.state.currentStep }
            />
        );
    }
}

// set display name
_CallAuthorizationFlowWidget.displayName = '_CallAuthorizationFlowWidget';

// set default props
_CallAuthorizationFlowWidget.defaultProps = {};

// prop types
_CallAuthorizationFlowWidget.propTypes = {};

/*************************************************/

// map state to props
const mapStateToProps = ( state ) => {
    return {
        callState: state[ REDUCER.CALL_STATE ],
        appContext: state[ REDUCER.APP_CONTEXT ],
    };
};

// map dispatch to props
const mapDispatchToProps = ( dispatch ) => {
    return {
        updateCallState: bindActionCreators( updateCallState, dispatch ),
    };
};

// return component with acccess to Redux store
export const CallAuthorizationFlowWidget = withRouter( connect( mapStateToProps, mapDispatchToProps )( _CallAuthorizationFlowWidget ) );
